var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { staticClass: "link-button -type04" }, [
    _vm._v(_vm._s(_vm.title) + "\n  "),
    _c("img", {
      staticClass: "arrow-image",
      attrs: {
        src: _vm.userOfferImageUrlForSp + "/icon_arrow_right_black.png",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }